import script from "./Video.vue?vue&type=script&setup=true&lang=ts"
export * from "./Video.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QVideo});
